var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C11.725 2.5 9.0625 5.1625 9.0625 8.4375C9.0625 11.65 11.575 14.25 14.85 14.3625C14.95 14.35 15.05 14.35 15.125 14.3625C15.15 14.3625 15.1625 14.3625 15.1875 14.3625C15.2 14.3625 15.2 14.3625 15.2125 14.3625C18.4125 14.25 20.925 11.65 20.9375 8.4375C20.9375 5.1625 18.275 2.5 15 2.5Z",
    fill: "#161F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3502 17.6876C17.8627 15.3626 12.1752 15.3626 8.6627 17.6876C7.0752 18.7501 6.2002 20.1876 6.2002 21.7251C6.2002 23.2626 7.0752 24.6876 8.6502 25.7376C10.4002 26.9126 12.7002 27.5001 15.0002 27.5001C17.3002 27.5001 19.6002 26.9126 21.3502 25.7376C22.9252 24.6751 23.8002 23.2501 23.8002 21.7001C23.7877 20.1626 22.9252 18.7376 21.3502 17.6876Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7aa5b977d04df9981eaedf61d88bdf44.svg";
export { ForwardRef as ReactComponent };